function findItem(items, itemId) {
    return items.find(({id}) => id === itemId);
}

export function buildTree(flattenedItems) {
    const root = {id: 'root', children: []};
    const nodes = {[root.id]: root};
    const items = flattenedItems.map((item) => ({...item, children: []}));

    for (const item of items) {
        const {id, children} = item;
        const parentId = item.parentId ?? root.id;
        const parent = nodes[parentId] ?? findItem(items, parentId);

        nodes[id] = {id, children};
        parent.children.push(item);
    }

    return root.children;
}

function flatten(
    items,
    parentId = null,
    depth = 0
) {
    return items.reduce((acc, item, index) => {
        return [
            ...acc,
            {...item, parentId, depth, index},
            ...flatten(item.children, item.id, depth + 1),
        ];
    }, []);
}

export function flattenTree(items) {
    return flatten(items);
}

